import React, {
  useEffect, useContext, useState,
} from 'react';
import { appStore, onAppMount } from './state/app';
import RenderRoutes from './components/RenderRoutes';
import routes from './routes';
import SystemMaintenance from './components/SystemMaintenance';
import { maintenanceMode } from './utils/maintenanceMode';
import MobileUnsupported from './components/MobileUnsupported/MobileUnsupported';

const Main = () => {
  const { dispatch, state } = useContext(appStore);
  const [maintenance, setMaintenance] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const onMount = () => {
    dispatch(onAppMount());
  };

  useEffect(onMount, []);

  useEffect(async () => {
    const res = await maintenanceMode();
    setMaintenance(res);
  }, []);

  useEffect(() => {
    const media = window.matchMedia('(max-width: 768px)');
    const handleChange = () => setIsMobile(media.matches);
    handleChange();
    if (media.addEventListener) {
      media.addEventListener('change', handleChange);
      return () => media.removeEventListener('change', handleChange);
    }
    media.addListener(handleChange);
    return () => media.removeListener(handleChange);
  }, []);

  if (maintenance) {
    return <SystemMaintenance />;
  }

  if (isMobile) {
    return <MobileUnsupported />;
  }

  return (
    <>
      {state?.loadedKeys && <RenderRoutes routes={routes} />}
    </>
  );
};

export default React.memo(Main);
